import React, { useState } from 'react';
import { useDispatch } from 'react-redux';

import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import { Box, Typography, IconButton } from '@mui/material';

import { snackbar } from 'src/components/common/snackbar/Snackbar';
import PageWithLayout from 'src/components/layout/PageWithLayout';
import { CreateUserDrawer } from 'src/features/user/components/CreateUserDrawer';
import { UserTable } from 'src/features/user/components/UserTable';
import {
	ICreateUserFormData,
	ICreateUserRequest,
} from 'src/features/user/domain/types';
import { createUser } from 'src/features/user/store/userThunks';
import { AppDispatch } from 'src/store';

const UsersPage: React.FC = () => {
	const breadcrumbs = [{ label: 'Users' }];
	const [isCreateDrawerOpen, setIsCreateDrawerOpen] = useState(false);
	const [shouldRefreshTable, setShouldRefreshTable] = useState({
		refreshTable: false,
	});
	const dispatch = useDispatch<AppDispatch>();

	const handleAddUser = () => {
		setIsCreateDrawerOpen(true);
	};

	const handleCreateUser = async (userData: ICreateUserFormData) => {
		const requestData: ICreateUserRequest = {
			first_name: userData.firstName,
			last_name: userData.lastName,
			type: userData.type === 'superadmin' ? 'super_admin' : 'general',
			email: userData.email,
			password: userData.password,
		};

		await dispatch(
			createUser({
				request: requestData,
				onSuccess: () => {
					snackbar('User created successfully', 'success');
					setIsCreateDrawerOpen(false);
					setShouldRefreshTable({ refreshTable: true });
				},
			}),
		);
	};

	return (
		<PageWithLayout breadcrumbs={breadcrumbs}>
			<Box sx={{ p: 0.5 }}>
				<Box
					sx={{
						display: 'flex',
						flexDirection: 'column',
						gap: 3,
						padding: 3,
						backgroundColor: 'white',
						borderRadius: '4px',
						marginTop: '20px',
					}}
				>
					{/* Header Section */}
					<Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
						<Typography
							variant='h6'
							sx={{
								fontSize: '20px',
								fontWeight: 500,
								color: 'rgba(0, 0, 0, 0.87)',
							}}
						>
							Users
						</Typography>
						<IconButton
							sx={{
								padding: 0,
								'&:hover': {
									backgroundColor: 'transparent',
								},
							}}
							onClick={handleAddUser}
						>
							<AddCircleOutlineIcon
								sx={{
									fontSize: '20px',
									color: 'rgba(0, 0, 0, 0.54)',
								}}
							/>
						</IconButton>
					</Box>

					{/* Table Section */}
					<UserTable refreshTable={shouldRefreshTable} />
				</Box>
				<CreateUserDrawer
					open={isCreateDrawerOpen}
					onClose={() => setIsCreateDrawerOpen(false)}
					onSubmit={handleCreateUser}
				/>
			</Box>
		</PageWithLayout>
	);
};

export default UsersPage;
